"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastMapKey = void 0;
const last_map_entry_1 = require("./last-map-entry");
exports.lastMapKey = (map) => last_map_entry_1.lastMapEntry(map)[0];
//# sourceMappingURL=last-map-key.js.map